import React from 'react'
import Link from 'gatsby-link'
import RightFooter from '../components/Footer'
import { withRouter } from 'react-router'

class ContentRight extends React.Component {
  render() {
    const { location, children } = this.props
    console.debug(this.props);

    let content = (
      <div id="page">
        {children()}
      </div>
    );

    let pageClass = this.props.location.pathname.substr(1).length ? this.props.location.pathname.substr(1) : 'home';

    return (
      <div id="content-right" className={`content ${pageClass} ${this.props.location.pathname !== '/' ? 'has-parky' : ''}`}>
        {content}
        <RightFooter isNavHidden={true}/>
      </div>
    )
  }
}

export default withRouter(ContentRight)


// WEBPACK FOOTER //
// ./src/components/ContentRight.js